import { render, staticRenderFns } from "./style-guide.vue?vue&type=template&id=1fd2e6cd&scoped=true&"
import script from "./style-guide.vue?vue&type=script&lang=js&"
export * from "./style-guide.vue?vue&type=script&lang=js&"
import style0 from "./style-guide.vue?vue&type=style&index=0&id=1fd2e6cd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd2e6cd",
  null
  
)

export default component.exports